interface CustomBotCardProps {
	onContactClick: () => void;
}

export function CustomBotCard({ onContactClick }: CustomBotCardProps) {
	return (
		<div className="mx-auto mt-8 max-w-2xl" id="custom-bot">
			<div className="relative overflow-hidden rounded-xl border border-slate-600 bg-gradient-to-br from-slate-800/60 to-slate-900/60 p-8 text-center">
				{/* Background decoration */}
				<div className="absolute inset-0 bg-gradient-to-br from-sesh-primary/5 to-transparent"></div>

				{/* Enterprise badge */}
				<div className="relative mb-6">
					<div className="inline-flex items-center gap-2 rounded-full border border-sesh-primary/30 bg-sesh-primary/10 px-4 py-1">
						<i className="fas fa-crown text-sesh-primary"></i>
						<span className="text-sm font-semibold text-sesh-primary">
							Enterprise
						</span>
					</div>
				</div>

				{/* Title and description */}
				<div className="relative mb-8">
					<h3 className="mb-4 text-3xl font-bold text-white">
						Custom <span className="sesh-text">sesh</span> Instance
					</h3>
					<p className="mx-auto max-w-lg text-lg leading-relaxed text-slate-300">
						Need something beyond our premium features? Get your own
						custom version of{" "}
						<span className="sesh-text">sesh</span> with
						personalized branding and features tailored to your
						organization.
					</p>
				</div>

				{/* Features */}
				<div className="relative mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
					{[
						{
							icon: "fas fa-robot",
							text: "sesh with Your Branding",
						},
						{
							icon: "fas fa-palette",
							text: "Custom Avatar & Bot Name",
						},
						{ icon: "fas fa-cogs", text: "Custom sesh Features" },
						{ icon: "fas fa-plug", text: "Custom Integrations" },
						{
							icon: "fas fa-headset",
							text: "Dedicated Support Channel",
						},
						{
							icon: "fas fa-shield-alt",
							text: "Enterprise-Grade Security",
						},
					].map((feature, index) => (
						<div
							key={index}
							className="flex items-center gap-3 text-left"
						>
							<div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-sesh-primary/20">
								<i
									className={`${feature.icon} text-sm text-sesh-primary`}
								></i>
							</div>
							<span className="text-sm text-slate-200">
								{feature.text}
							</span>
						</div>
					))}
				</div>

				{/* CTA */}
				<div className="relative">
					<button
						onClick={onContactClick}
						className="group inline-flex items-center gap-2 rounded-lg bg-sesh-primary px-8 py-3 font-semibold text-slate-900 transition-all duration-200 hover:scale-105 hover:bg-sesh-primary/90 focus:outline-none focus:ring-2 focus:ring-sesh-primary/50"
					>
						<span>Contact Us</span>
						<i className="fas fa-arrow-right text-sm transition-transform duration-200 group-hover:translate-x-1"></i>
					</button>
					<p className="mt-3 text-xs text-slate-400">
						Get a custom quote based on your needs
					</p>
				</div>
			</div>

			{/* Alternative option */}
			<div className="mt-6 rounded-lg border border-slate-700 bg-slate-800/30 p-4 text-center">
				<div className="flex items-center justify-center gap-2">
					<i className="fas fa-robot text-lg text-sesh-primary/70"></i>
					<span className="text-sm text-slate-300">
						Looking for a completely custom bot? Check out{" "}
						<a
							href="https://tunkslabs.com"
							target="_blank"
							rel="noopener noreferrer"
							className="text-sesh-primary hover:underline"
						>
							Tunks Labs
						</a>
					</span>
				</div>
			</div>
		</div>
	);
}
